<template>
  <div class="event">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push({path:'/'})">
        <img src="../assets/img/logo.svg" alt>
      </a>
      <a class="menu_btn" href="javascript:;" @click="$router.push({path:'/more'})">
        <img src="../assets/img/menu.png" alt>
      </a>
    </div>
    <!-- <div class="app">
      <a class="logo" href="http://a.app.qq.com/o/simple.jsp?pkgname=net.trendbank.zp.trendbank">
        <img src="../assets/img/appTrendBendss.png" alt>
      </a>
    </div> -->
    <div v-if="singUpshow" class="signUp" @click="singUp(detail)">
      <!-- <img src="../assets/img/signUpbtn.gif" alt> -->
      <span>立即报名</span>
    </div>
    <div class="content">
      <!-- <div style="display: none" ref="catalog">{{ detail.catalog }}</div> -->
      <p class="title">{{ detail.title }}</p>
      <!-- <p class="date">
        {{ detail.source }}
        <span>{{time}}</span>
      </p> -->
      <div class="content_detail">
        <p v-html="detail.catalog"></p>
      </div>
      <div v-for="item in detail.files" :key="item.id">
        <div class="free-down" @click="freeDown(item.id)">
          <img src="../assets/img/Shape.png" alt>免费下载附件
        </div>
      </div>
    </div>
    <detail-footer></detail-footer>
  </div>
</template>

<script>
import DetailFooter from "./_footer";
import avatar from "../assets/img/avatar.png";
import router from "../router";
// import { getToken } from "../utils/auth";
import { MessageBox } from "mint-ui";
export default {

  components: {
    DetailFooter
  },
  data() {
    return {
      detail: {},
      name: "匿名用户",
      pageSize: 10,
      hasMoreComment: false,
      option_disabled: false,
      related_info: {},
      categoryName: "",
      pageInfo: {
        params: {
          size: 10,
          contentId: 0,
          page: 1
        },
        // postUrl: "/api/web/phone/content/comment-list"
      },
      singUpshow: false,
      nowTime: "",
      hh: ""
    };
  },
  watch: {
    $route() {
      this.init();
    }
  },
  beforeCreate() {
    //同一组件跳转去头部
    router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  created() {},
  mounted() {
    this.init();
  },
  computed: {
    time() {
      if (!this.detail.time || this.detail.time.length < 10) return "";
      return this.detail.time.substr(0, 10).replace(/-/g, "/");
    }
  },
  methods: {
    // 免费下载
    freeDown(id) {
      console.log('aaa',id)
      this.$axios.get("/pub/upload/download?fileId=" + id, {}).then(res => {
        if (res.code == 200) {
          if (res.data.downloadTag) {
            document.location = res.data.fileUrl;
            MessageBox({
              title: "下载",
              message: "下载成功",
              showCancelButton: true
            });
          } else {
            MessageBox({
              title: "提示",
              message: res.data.message,
              showCancelButton: true
            });
          }
        } else {
          MessageBox("提示", res.message);
        }
      });
    },

    init() {
      // console.log(window.location.href)
      let url = window.location.href
      let weeklyId = url.substring(url.lastIndexOf("/")+1);
      this.$axios.get(`/api/web/phone/weekly/${weeklyId}`, {})
        .then(res => {
          if(res.data.enrollSwitch == true) {
            this.singUpshow = true;
          }else {
            this.singUpshow = false;
          }
          // this.hh = res.data.startTime;
          console.log('返回数据', res)
          if (res.data.hasOwnProperty("currentCategoryCode")) {
            if (res.data.currentCategoryCode.slice(0, 1) == "9") {
              // this.timeFormate();
            } else {
              this.singUpshow = false;
            }
          }
          this.detail = res.data ? res.data : {};
          this.option_disabled = this.detail.likeTag || this.detail.treadTag;
          document.title = this.detail.title;
          localStorage.setItem("herf", window.location.href);
          this.wxShare(
            this.detail.title,
            this.detail.description,
            this.detail.thumbApp,
            ''
          );
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
.disabled {
  pointer-events: none;
  // opacity: .5;
}
.event {
  background: #f5f5f5;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  overflow: auto;
}
.app {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 52px;
  z-index: 999;
  a {
    width: 100%;
    height: 100%;
    img{
      height:40px;
    }
  }
}
.signUp {
  width: 100%;
  height: 50px;
  line-height: 50px;
  position: fixed;
  bottom: 0;
  z-index: 999;
  background: #fa9d00;
  img {
    width: 65px;
  }
  span {
    color: #fff;
  }
}
.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;
  .logo {
    display: inline-block;
    // width: 133px;
    // height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;
    img {
      height: 35px;
    }
  }
  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.tab_box {
  z-index: 99;
  height: 54px;
  top: 54px;
  left: 0;
  right: 0;
  position: fixed;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  background: #f5f5f5;
  text-align: left;
  overflow: hidden;
  ul {
    padding: 0;
    margin: 0;
    display: inline-block;
    border-bottom: 3px solid #df964d;
    width: 100%;
  }
  ul li {
    margin: 0;
    display: inline-block;
    padding: 0 10px;
  }
  i {
    display: inline-block;
    width: 6px;
    height: 100%;
    img {
      display: inline-block;
      width: 100%;
      position: relative;
      top: -1px;
    }
  }
  .tab_item {
    display: inline-block;
    padding: 15px 10px;
    color: #666666;
    font-size: 16px;
    box-sizing: border-box;
    position: relative;
  }
}
.content {
  min-height: calc(100vh - 66px);
  box-sizing: border-box;
  padding-top: 56px;
  background-color: #fff;
  // border-bottom: 1px solid #e0e0e0;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 16px;
  .title {
    font-size: 20px;
    padding-top: 15px;
    font-weight: 700;
    color: #333;
    text-align: left;
  }
  .date {
    width: 100%;
    text-align: left;
    margin-top: 15px;
    margin-bottom: 10px;
    color: #2a95d3;
    float: left;
    font-size: 14px;
    span {
      padding-left: 15px;
      color: #999;
    }
  }

  .content_detail {
    padding-top: 16px;
    width: 345px;
    padding-bottom: 30px;
    // border-bottom: 1px solid #e0e0e0;
    text-align: left;
    // p {
    //   font-size: 16px;
    //   color: #666;
    //   line-height: 20px;
    //   padding-bottom: 30px;
    // }
  }
  .thumb {
    display: flex;
    justify-content: center;
    padding-top: 30px;
    margin-bottom: 26px;
    font-size: 14px;
    .down,
    .up {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .up {
      margin-right: 170px;
      color: #fd6262;
    }
    .down {
      color: #64a9ff;
    }
    img {
      width: 30px;
      height: 30px;
    }
  }
}
.comment {
  border-radius: 5px;
  border: 1px solid#E1E1E1;
  height: 44px;
  line-height: 44px;
  input {
    display: inline-block;
    padding-left: 20px;
    width: 276px;
  }
  .amount {
    padding-right: 20px;
    font-size: 10px;
  }
}


.bottom {
  width: 345px;
  margin-top: 40px;
  margin-left: 15px;
  margin-right: 15px;
  // .news_info,
  .news_title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .news {
    color: #df964d;
    height: 25px;
    font-size: 18px;
    line-height: 25px;
    text-align: left;
    padding-bottom: 6px;
    border-bottom: 1px solid #e0e0e0;
  }
  .news_title {
    color: #333333;
    margin-top: 15px;
    margin-bottom: 10px;
    text-align: left;
    height: 44px;
    font-size: 16px;
    line-height: 22px;
    -webkit-line-clamp: 2;
  }
  .news_info {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 18px;
    font-size: 13px;
    line-height: 18px;
    -webkit-line-clamp: 1;
    margin-bottom: 27px;
  }
  .exit {
    margin-bottom: 21px;
    .exit_btn {
      width: 345px;
      background: #df964d;
      border-radius: 5px;
      color: #ffffff;
      display: inline-block;
      text-align: center;
      height: 41px;
      border-radius: 5px;
      font-size: 18px;
      line-height: 41px;
    }
  }
}
.free-down {
  display: block;
  line-height: 35px;
  background-color: #64a9ff;
  font-size: 12px;
  color: #fff;
  border-radius: 4px;
  img {
    width: 12px;
    margin-right: 10px;
  }
}
</style>
<style>
.content_detail img {
  width: 100%;
  height: auto;
}
.content_detail p {
  font-size: 16px;
  color: #666;
  line-height: 26px;
  padding-bottom: 20px;
}
img {
  content: normal !important;
}
</style>



// WEBPACK FOOTER //
// src/components/weeklyDetail.vue